/**
 * PostHog group type used to model an organization for group analytics and
 * group feature flags. This key must match exactly between the client
 * (`posthog.group(...)`) and the server (`groups`/`groupIdentify`) for events
 * to roll up to the same group, so it lives in this dependency-free module that
 * both sides can import (the client bundle must not pull in `posthog-node`).
 */
export const ORGANIZATION_GROUP_TYPE = "organization";
